export default () => ({
    isLoading: false,
    entries: [
        
    ]
})